const styles = theme => ({
  root: {
    margin: "20px 0", 
    lineHeight: 2,
  },

  navLink: {
    alignItems: "center",
    display: "flex",
    height: 24,
    backgroundColor: "#e1e1e1",
    padding: "5px 15px",
    borderRadius: 12,
    "&:hover": {
      color: "white",
      backgroundColor: theme.colors.primary
    }
  },
  lastBreadcrumbs: {
    alignItems: "center",
    position: 'relative',
    color: "white",
    height: 24,
    backgroundColor: theme.colors.primary,
    padding: "0px 15px",
    borderRadius: 12,

    maxWidth: "100%",
    display: "-webkit-box",
    overflow: "hidden",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 1,
    lineHeight: '24px',

    '& svg': {
      transform: 'translateY(2px)'
    }
  },
  icon: {
    marginRight: 5
  }
});

export default styles;
